ModalLinkController.$inject = []

export default function ModalLinkController() {
  var vm = this

}